export default "__VITE_ASSET__DYJDeT8s__"